/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */

import React, { useState } from 'react';
import LabeledInputWithBlur from '../../../../sharedmodules/components/form-fields/labeled-input-with-blur';
import MultipleSearchCriteria from './multiple-search-criteria';
import PropTypes from 'prop-types';

const PinPlateInputField = ({ handleExecute, handleReset }) => {

    const [pinPlateDetails, setPinPlateDetails] = useState({
        pins: '',
        dealerAccounts: '',
        requesterTCSMs: '',
        factoryCodes: '',
        status: '',
        fromDateSubmmited: '',
        toDateSubmmited: '',
        fromUpdatedTs: '',
        toUpdatedTs: '',
    });

    const [isMultipleVisible, setIsMultipleVisible] = useState(false);
    const isVsrError = '';

    const [fieldTouch, setFieldTouched] = useState({
        pins: false,
        dealerAccounts: false,
        requesterTCSMs: false,
        factoryCodes: false,
        status: false,
        fromDateSubmmited: false,
        toDateSubmmited: false,
        fromUpdatedTs: false,
        toUpdatedTs: false,
    });
    const [label, setLabel] = useState('');

    const handleInputChange = (e) => {

        e.preventDefault();
        const { name, value } = e.target;

        setPinPlateDetails({
            ...pinPlateDetails,
            [name]: value,
        });

        setFieldTouched({
            ...fieldTouch,
            [name]: true,
        });

    };

    const isValidDetails = false;

    const validateExecuteButton = () => pinPlateDetails.status === '' || pinPlateDetails.status.trim() === '';

    const addMultipleData = (labelValue) => {

        setIsMultipleVisible(true);
        setLabel(labelValue);

    };

    const handleSubmit = (labelData, data) => {

        if (labelData === 'CREATED_DATE_FROM') {

            setPinPlateDetails({
                ...pinPlateDetails,
                fromDateSubmmited: data,
            });

        }
        if (labelData === 'CREATED_DATE_TO') {

            setPinPlateDetails({
                ...pinPlateDetails,
                toDateSubmmited: data,
            });

        }
        if (labelData === 'UPDATED_DATE_FROM') {

            setPinPlateDetails({
                ...pinPlateDetails,
                fromUpdatedTs: data,
            });

        }
        if (labelData === 'UPDATED_DATE_TO') {

            setPinPlateDetails({
                ...pinPlateDetails,
                toUpdatedTs: data,
            });

        }
        if (labelData === 'PIN') {

            setPinPlateDetails({
                ...pinPlateDetails,
                pins: data,
            });

        }
        if (labelData === 'DEALER_ACCOUNT') {

            setPinPlateDetails({
                ...pinPlateDetails,
                dealerAccounts: data,
            });

        }
        if (labelData === 'TCSM_ID') {

            setPinPlateDetails({
                ...pinPlateDetails,
                requesterTCSMs: data,
            });

        }
        if (labelData === 'FACTORY') {

            setPinPlateDetails({
                ...pinPlateDetails,
                factoryCodes: data,
            });

        }
        if (labelData === 'STATUS') {

            setPinPlateDetails({
                ...pinPlateDetails,
                status: data,
            });

        }
        if (data !== '') {

            setIsMultipleVisible(false);

        }

    };

    return (
        <div className="dealer-settings-body">
            <div className="input-details">
                {/* Make the first three input fields in one row */}
                <div className="input-fields input-fields-row">
                    <LabeledInputWithBlur
                        className="user-id-small"
                        name="pins"
                        errorMessage="PIN_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="PIN"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        addMultipleData={addMultipleData}
                        value={pinPlateDetails.pins || ''}
                        addMultiple
                        vsrMessage={isVsrError}
                    />
                    <LabeledInputWithBlur
                        className="user-id-small"
                        name="fromUpdatedTs"
                        errorMessage="FROM_UPDATED_TS_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="UPDATED_DATE_FROM"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        value={pinPlateDetails.fromUpdatedTs || ''}
                        vsrMessage={isVsrError}
                        type="date"
                    />
                    <LabeledInputWithBlur
                        className="user-id-small required"
                        name="status"
                        errorMessage="STATUS_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="STATUS"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        addMultipleData={addMultipleData}
                        value={pinPlateDetails.status || ''}
                        addMultiple
                        vsrMessage={isVsrError}
                    />

                </div>
                <div className="input-fields input-fields-row">
                    <LabeledInputWithBlur
                        className="user-id-small"
                        name="fromDateSubmmited"
                        errorMessage="FROM_DATE_SUBMITTED_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="CREATED_DATE_FROM"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        value={pinPlateDetails.fromDateSubmmited || ''}
                        vsrMessage={isVsrError}
                        type="date"
                    />
                    <LabeledInputWithBlur
                        className="user-id-small"
                        name="toUpdatedTs"
                        errorMessage="TO_UPDATED_TS_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="UPDATED_DATE_TO"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        value={pinPlateDetails.toUpdatedTs || ''}
                        vsrMessage={isVsrError}
                        type="date"
                    />
                    <LabeledInputWithBlur
                        className="user-id-small"
                        name="dealerAccounts"
                        errorMessage="DEALER_ACCOUNT_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="DEALER_ACCOUNT"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        addMultipleData={addMultipleData}
                        value={pinPlateDetails.dealerAccounts || ''}
                        addMultiple
                        vsrMessage={isVsrError}
                    />
                </div>
                <div className="input-fields input-fields-row">
                    <LabeledInputWithBlur
                        className="user-id-small"
                        name="toDateSubmmited"
                        errorMessage="TO_DATE_SUBMITTED_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="CREATED_DATE_TO"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        value={pinPlateDetails.toDateSubmmited || ''}
                        vsrMessage={isVsrError}
                        type="date"
                    />
                    <LabeledInputWithBlur
                        className="user-id-small"
                        name="factoryCodes"
                        errorMessage="FACTORY_CODE_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="FACTORY"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        addMultipleData={addMultipleData}
                        value={pinPlateDetails.factoryCodes || ''}
                        addMultiple
                        vsrMessage={isVsrError}
                    />
                    <LabeledInputWithBlur
                        className="user-id-small"
                        name="requesterTCSMs"
                        errorMessage="REQUESTER_TCSM_IS_REQUIRED"
                        highlightClass={isValidDetails ? 'highlight-error' : ''}
                        isEditable
                        isValid
                        label="TCSM_ID"
                        handleBlur={handleInputChange}
                        handleChange={handleInputChange}
                        addMultipleData={addMultipleData}
                        value={pinPlateDetails.requesterTCSMs || ''}
                        addMultiple
                        vsrMessage={isVsrError}
                    />
                </div>
                {isMultipleVisible && (
                    <MultipleSearchCriteria
                        handleSubmit={handleSubmit}
                        label={label}
                        onClose={() => setIsMultipleVisible(false)}
                        pinPlateDetails={pinPlateDetails}
                    />
                )}
            </div>
            <div className="button-layout">
                <button
                    type="button"
                    onClick={() => {

                        setPinPlateDetails({
                            pins: '',
                            dealerAccounts: '',
                            requesterTCSMs: '',
                            factoryCodes: '',
                            status: '',
                            fromDateSubmmited: '',
                            toDateSubmmited: '',
                            fromUpdatedTs: '',
                            toUpdatedTs: '',
                        });
                        setFieldTouched({
                            pins: false,
                            dealerAccounts: false,
                            requesterTCSMs: false,
                            factoryCodes: false,
                            status: false,
                            fromDateSubmmited: false,
                            toDateSubmmited: false,
                            fromUpdatedTs: false,
                            toUpdatedTs: false,
                        });
                        handleReset();

                    }}
                >
                    Reset
                </button>
                <button type="button" id="execute" onClick={() => handleExecute(pinPlateDetails)} disabled={validateExecuteButton()}>
                    Execute
                </button>
            </div>
        </div>
    );

};

PinPlateInputField.propTypes = {
    handleExecute: PropTypes.func.isRequired,
    handleReset: PropTypes.func.isRequired,
};

export default PinPlateInputField;
